export default "__VITE_ASSET__Chuph2uj__"